import { render, staticRenderFns } from "./PurchaseDelivery.vue?vue&type=template&id=12bde58a&"
import script from "./PurchaseDelivery.vue?vue&type=script&lang=js&"
export * from "./PurchaseDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports